import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  faArrowLeft,
  faUpRightFromSquare,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import {
  FileType,
  GlobalFunctions,
} from 'globales-projekt-angular';
import { FileAppMetaDatas } from 'src/app/data/anwendung/file-app-meta-datas.model';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-hilfe',
  templateUrl: './hilfe.component.html',
  styleUrls: ['./hilfe.component.css'],
})
export class HilfeComponent implements OnInit {
  anwendungsname: string = ConstantsTexte.ANWENDUNGSNAME;
  showWaitingForDataSpinner: number = 0;
  faArrowLeft: IconDefinition = faArrowLeft;
  faUpRightFromSquare: IconDefinition = faUpRightFromSquare;

  fileAppMetaDatas: FileAppMetaDatas = new FileAppMetaDatas(this.apiService);

  constructor(private apiService: ApiService, private location: Location) {}

  ngOnInit(): void {    
    this.fileAppMetaDatas.loadFileAppMetaDatas();
  }

  openInTabNutsZweiRegionen() {
    this.openInTab(
      this.fileAppMetaDatas.nuts_zwei_regionen.type,
      DateiTyp.NUTS_ZWEI_REGIONEN
    );
  }

  openInTab(type: FileType, dateiTyp: DateiTyp) {
    this.showWaitingForDataSpinner++;
    this.apiService.getAppFileDocuments(dateiTyp).subscribe((response) => {
      GlobalFunctions.openInTab(response, type);

      this.showWaitingForDataSpinner--;
    });
  }

  goBack() {
    this.location.back();
  }
}
